import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class UpdatePlatformStatusRTDBV2Command extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUpdatePlatformStatusRTDBV2Parameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/updPlatformStatusRTDB/{nodo}';

  public override setParameters(parameters: IUpdatePlatformStatusRTDBV2Parameters) {
    this._commandUrl = this._commandUrl
      .replace('{carrierId}', parameters.carrierId ? parameters.carrierId.toString() : '')
      .replace('{nodo}', parameters.nodo ? parameters.nodo : '');
  }
}

export interface IUpdatePlatformStatusRTDBV2Parameters {
  carrierId: string;
  nodo: string;
}
